export interface TokenPayload {
  exp: number;
  iat: number;
  sub: string;
  email: string;
  role: string;
}

export const isTokenExpired = (token: string): boolean => {
  try {
    const payload = JSON.parse(atob(token.split('.')[1])) as TokenPayload;
    const currentTime = Date.now() / 1000;
    return payload.exp < currentTime;
  } catch (error) {
    console.error('Error parsing token:', error);
    return true; // If we can't parse the token, consider it expired
  }
};

export const getTokenPayload = (token: string): TokenPayload | null => {
  try {
    return JSON.parse(atob(token.split('.')[1])) as TokenPayload;
  } catch (error) {
    console.error('Error parsing token payload:', error);
    return null;
  }
};

export const getTokenTimeLeft = (token: string): number => {
  const payload = getTokenPayload(token);
  if (!payload) return 0;
  
  const currentTime = Date.now() / 1000;
  return Math.max(0, payload.exp - currentTime);
};

export const formatTokenTimeLeft = (token: string): string => {
  const timeLeft = getTokenTimeLeft(token);
  if (timeLeft <= 0) return 'Expired';
  
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor((timeLeft % 3600) / 60);
  const seconds = Math.floor(timeLeft % 60);
  
  if (hours > 0) {
    return `${hours}h ${minutes}m ${seconds}s`;
  } else if (minutes > 0) {
    return `${minutes}m ${seconds}s`;
  } else {
    return `${seconds}s`;
  }
};
